module.exports = __webpack_public_path__ + "static/media/adsk-projects.2b9bcb4e.txt";